import type { SingPitchId } from './clingCantaConfig';
import { SING_PITCH_BY_ID } from './clingCantaConfig';

export function midiNearPitch(midi: number, pitchId: SingPitchId, cents = 120): boolean {
  const target = SING_PITCH_BY_ID[pitchId]?.midi;
  if (target == null) return false;
  return Math.abs(midi - target) * 100 <= cents;
}
